export const GET_PARTICIPANTS = 'GET_PARTICIPANTS';
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
export const UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS = 'UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS';
export const UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL = 'UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL';
export const UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY = 'UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY';
